export default "__VITE_ASSET__Cyedr1_m__"